import { createContext } from 'react';

const CourseInformationContext = createContext(null);

export default CourseInformationContext;



// WEBPACK FOOTER //
// ./components/groups/context/course-information-context.js